import { memo } from "react";

import type { MagazineAnalyticsSetting_DesignPageQuery } from "@/lib/gql/__generated__/graphql";

import { FeatureIslandContainer, FeatureIslandMainWithBackGround } from "@/components/features/_layouts";

import { Button } from "@/components/ui/button/button";

import { GuestPageVisibilityQuestion } from "@/components/features-new/guest-page-visibility";

import { DesignMagazineAnalyticsSettingGTMIsland } from "./gtm-island";
import { useDesignMagazineAnalyticsSetting } from "./hooks/use-design-magazine-analytics-setting/use-design-magazine-analytics-setting";
import { DesignMagazineAnalyticsSettingPixelIsland } from "./pixel-island";
import { DesignMagazineHeaderAndTab } from "../../../list/_shared/ui/components/header-and-tab";
import { useInitialized } from "../../model/use-case";

import type { ComponentProps } from "react";

type Props = {
	serverModel: MagazineAnalyticsSetting_DesignPageQuery;
	hotelID: string;
};

export const DesignMagazineAnalyticsSettingPresenter = memo(({ hotelID, serverModel }: Props) => {
	const { viewModel, magazineAnalyticsSettingFormModelMethods, onUpdate } = useInitialized({ serverModel });
	const { isValid } = useDesignMagazineAnalyticsSetting({ viewModel });
	const variant: ComponentProps<typeof Button>["variant"] = isValid ? "default" : "disabled";

	const { onSetGtmAvailable, onSetGtmID, onSetPixelAvailable, onSetPixelID, onSetGuestPageUnlisted } =
		magazineAnalyticsSettingFormModelMethods;

	return (
		<FeatureIslandContainer>
			<DesignMagazineHeaderAndTab
				hotelID={hotelID}
				headerProps={{
					rightChildren: (
						<Button type="button" onClick={onUpdate} variant={variant} size="xl">
							保存
						</Button>
					),
				}}
			/>

			<DesignMagazineAnalyticsSettingGTMIsland
				viewModel={viewModel}
				onSetGtmAvailable={onSetGtmAvailable}
				onSetGtmID={onSetGtmID}
			/>

			<DesignMagazineAnalyticsSettingPixelIsland
				viewModel={viewModel}
				onSetPixelAvailable={onSetPixelAvailable}
				onSetPixelID={onSetPixelID}
			/>

			<FeatureIslandMainWithBackGround islandTitle="検索エンジンへの表示">
				<GuestPageVisibilityQuestion
					visibility={viewModel.guestPageVisibility.value}
					onChangeUnlisted={onSetGuestPageUnlisted}
				/>
			</FeatureIslandMainWithBackGround>
		</FeatureIslandContainer>
	);
});

DesignMagazineAnalyticsSettingPresenter.displayName = "DesignMagazineAnalyticsSettingPresenter";
